/** Query key factory (inline array literals are banned — CLAUDE.md). */
export const sessionKeys = {
  all: () => ['session'] as const,
  me: () => [...sessionKeys.all(), 'me'] as const,
  device: (userCode: string) => [...sessionKeys.all(), 'device', userCode] as const,
}
